import React from 'react'

import { EmptyState, Text } from '@plurall/elo-beta'

import styles from './Error.module.css'

const Error = () => {
  return (
    <div className={styles['container-card-empty']}>
      <EmptyState variation='using-laptop' bg='mask' title='Ops! Algo deu errado'>
        <div className={styles['card-description']}>
          <Text size='t3' alignment='center' dimmed>
            Por favor, tente novamente. Se o problema persistir, entre em contato com o nosso
            suporte.
          </Text>
        </div>
      </EmptyState>
    </div>
  )
}

export default Error
